import React from 'react';

export const QuestionarioCasasStepTwo = ({
  formData,
  handleChange,
  handleSocialItemToggle,
  serviceOptions,
  consultationOptions,
  workOptions,
  socialItems,
}) => {
  return (
    <div className="space-y-6" data-testid="questionario-casas-step-2">
      <div>
        <p className="font-medium text-gray-800 mb-3" data-testid="questionario-casas-service-label">Qual serviço você procura? *</p>
        <div className="grid sm:grid-cols-3 gap-3">
          {serviceOptions.map((option) => (
            <label key={option.value} className={`p-4 border-2 rounded-xl cursor-pointer ${formData.serviceCategory === option.value ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-blue-300'}`} data-testid={`questionario-casas-service-option-${option.value}`}>
              <input type="radio" name="serviceCategory" value={option.value} checked={formData.serviceCategory === option.value} onChange={handleChange} className="sr-only" data-testid={`questionario-casas-service-radio-${option.value}`} />
              <p className="text-2xl mb-2">{option.icon}</p>
              <p className="font-semibold text-gray-900">{option.label}</p>
              <p className="text-xs text-gray-500">{option.description}</p>
            </label>
          ))}
        </div>
      </div>

      <select name="consultationType" value={formData.consultationType} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500" data-testid="questionario-casas-consultation-type-select">
        <option value="">Tipo de consulta *</option>
        {consultationOptions.map((option) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </select>

      <div>
        <p className="font-medium text-gray-800 mb-2" data-testid="questionario-casas-work-type-label">Trabalho *</p>
        <div className="grid sm:grid-cols-2 gap-2">
          {workOptions.map((option) => (
            <label key={option.value} className="flex items-center gap-2 text-sm" data-testid={`questionario-casas-work-option-${option.value}`}>
              <input type="radio" name="workType" value={option.value} checked={formData.workType === option.value} onChange={handleChange} data-testid={`questionario-casas-work-radio-${option.value}`} />
              <span>{option.label}</span>
            </label>
          ))}
        </div>
      </div>

      <div>
        <p className="font-medium text-gray-800 mb-2" data-testid="questionario-casas-social-items-label">Marque os itens que você possui</p>
        <div className="grid sm:grid-cols-2 gap-2">
          {socialItems.map((item) => (
            <label key={item} className="flex items-center gap-2 text-sm" data-testid={`questionario-casas-social-item-${item.replace(/\s+/g, '-').toLowerCase()}`}>
              <input type="checkbox" checked={formData.socialItems.includes(item)} onChange={() => handleSocialItemToggle(item)} data-testid={`questionario-casas-social-checkbox-${item.replace(/\s+/g, '-').toLowerCase()}`} />
              <span>{item}</span>
            </label>
          ))}
        </div>
      </div>

      <div>
        <p className="font-medium text-gray-800 mb-2" data-testid="questionario-casas-other-consultation-label">Já buscou atendimento com outra imobiliária/empresa? *</p>
        <div className="flex gap-6">
          <label className="flex items-center gap-2" data-testid="questionario-casas-other-consultation-yes-option">
            <input type="radio" name="hasOtherRealEstateConsultation" value="sim" checked={formData.hasOtherRealEstateConsultation === 'sim'} onChange={handleChange} data-testid="questionario-casas-other-consultation-yes-radio" />
            <span>Sim</span>
          </label>
          <label className="flex items-center gap-2" data-testid="questionario-casas-other-consultation-no-option">
            <input type="radio" name="hasOtherRealEstateConsultation" value="nao" checked={formData.hasOtherRealEstateConsultation === 'nao'} onChange={handleChange} data-testid="questionario-casas-other-consultation-no-radio" />
            <span>Não</span>
          </label>
        </div>
      </div>
    </div>
  );
};
